<template>
  <v-container fluid :class="proMode ? 'proBground' : ''" style="height: 100vh;">
    <div v-if="statuses.length==0" class="text-center" style="margin-top:20%">
        <v-progress-circular
        indeterminate
        size="100"
        width="3"
        :color="(proMode ? 'light-green':'teal')"
        ></v-progress-circular>
    </div>
    <v-data-iterator
      v-else
      :items="statuses"
      :items-per-page.sync="itemsPerPage"
      :page="page"
      :search="search"
      :sort-by="sortBy.toLowerCase()"
      :sort-desc="sortDesc"
      :dark="proMode"
      hide-default-footer
       :style="'min-height: ' + itHeight + 'px !important;max-height: ' + itHeight + 'px !important'"
    >
      <template v-slot:header >
        <v-row no-gutters>
          <v-col cols="12" class="mb-1">
            <v-text-field
              v-model="search"
              clearable
              flat
              outlined
              dense
              block
              hide-details
              prepend-inner-icon="mdi-magnify"
              label="Search"
            ></v-text-field>
          </v-col>
        </v-row>
      </template>

      <template v-slot:default="props">
        <v-row :style="'max-height: ' + itHeight + 'px !important; min-height: ' + itHeight + 'px !important; overflow-x:hidden; overflow-y:scroll'">
          <v-col
            v-for="item in props.items"
            :key="item.facility"
            cols="12"
            sm="6"
            md="4"
            lg="3"
          >
            <v-card @click="openFacility(item.facility,item.client,item.facility_display,item.client_display)" :class="(proMode ? 'proColor proFont ' : 'lightBground ')" :color="proMode ? '' : 'teal lighten-4'" >
              <v-card-title class="subheading font-weight-bold">
                {{ item.facility_display }}
              </v-card-title>

              <v-divider></v-divider>

              <v-list dense :color="proMode ? '' : 'teal lighten-4'">
                <v-list-item>
                  <v-list-item-content :class="(proMode ? 'proColor proFont ' : ' ')" >
                    Client:
                  </v-list-item-content>
                  <v-list-item-content
                    class="text-center liDiFix"
                  >
                    {{ item.client_display }}
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content :class="(proMode ? 'proColor proFont ' : ' ')" >
                    NEW:
                  </v-list-item-content>
                  <v-list-item-content
                    class="text-center liDiFix"
                  >
                    {{ item.new }}
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content :class="(proMode ? 'proColor proFont ' : ' ')" >
                    UPDATED:
                  </v-list-item-content>
                  <v-list-item-content
                    class="text-center liDiFix"
                  >
                    {{ item.updated }}
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content :class="(proMode ? 'proColor proFont ' : ' ')" >
                    IN PROGRESS:
                  </v-list-item-content>
                  <v-list-item-content
                    class="text-center liDiFix"
                  >
                    {{ item.in_progress }}
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content :class="(proMode ? 'proColor proFont ' : ' ')" >
                    INCOMPLETE:
                  </v-list-item-content>
                  <v-list-item-content
                    class="text-center liDiFix"
                  >
                    {{ item.incomplete }}
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content :class="(proMode ? 'proColor proFont ' : ' ')" >
                    QA:
                  </v-list-item-content>
                  <v-list-item-content
                    class="text-center liDiFix"
                  >
                    {{ item.qa }}
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content :class="(proMode ? 'proColor proFont ' : ' ')" >
                    DEFICIENT:
                  </v-list-item-content>
                  <v-list-item-content
                    class="text-center liDiFix"
                  >
                    {{ item.deficient }}
                  </v-list-item-content>
                </v-list-item>
                <!-- <v-list-item>
                  <v-list-item-content :class="(proMode ? 'proColor proFont ' : ' ')" >
                    WAITING:
                  </v-list-item-content>
                  <v-list-item-content
                    class="text-center liDiFix"
                  >
                    {{ item.waiting }}
                  </v-list-item-content>
                </v-list-item> -->
                <v-list-item>
                  <v-list-item-content :class="(proMode ? 'proColor proFont' : ' ')" >
                    COMPLETE:
                  </v-list-item-content>
                  <v-list-item-content
                    class="text-center liDiFix"
                  >
                    {{ item.complete }}
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content :class="(proMode ? 'proColor proFont ' : ' ')" >
                    EXPORT:
                  </v-list-item-content>
                  <v-list-item-content
                    class="text-center liDiFix"
                  >
                    {{ item.export }}
                  </v-list-item-content>
                </v-list-item>
              </v-list>

              <!-- <v-list dense>
                <v-list-item
                  v-for="(key, index) in filteredKeys"
                  :key="index"
                >
                  <v-list-item-content >
                    {{ key }}:
                  </v-list-item-content>
                  <v-list-item-content
                    class="text-center liDiFix"
                    :class="{ 'blue--text': sortBy === key }"
                  >
                    {{ item[key.toLowerCase()] }}
                  </v-list-item-content>
                </v-list-item>
              </v-list> -->
            </v-card>
          </v-col>
        </v-row>
      </template>
      <template v-slot:footer>
        <v-row
          class="ma-0 px-2"
          align="center"
          justify="center"
        >
          <span :class="(proMode ? 'light-green--text' : 'teal--text text--darken-4')">Facilities per page</span>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :dark="proMode"
                text
                :color="(proMode ? 'light-green' : 'teal darken-4')"
                class="ml-2"
                v-bind="attrs"
                v-on="on"
              >
                {{ itemsPerPage }}
                <v-icon>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list 
              :dark="proMode"
              dense
            >
              <v-list-item
                v-for="(number, index) in itemsPerPageArray"
                :key="index"
                @click="updateItemsPerPage(number)"
              >
                <v-list-item-title
                  :class="(proMode ? 'light-green--text' : 'teal--text text--darken-4')"
                >{{ number }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-spacer></v-spacer>

          <span
            :class="'mr-4 ' + (proMode ? 'light-green--text' : 'teal--text text--darken-4')"
          >
            Page {{ page }} of {{ numberOfPages }}
          </span>
          <v-btn
            text
            small
            :dark="proMode"
            :color="(proMode ? 'light-green' : 'teal darken-4')"
            class="mr-1"
            @click="formerPage"
          >
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn
            text
            small
            :dark="proMode"
            :color="(proMode ? 'light-green' : 'teal darken-4')"
            class="ml-1"
            @click="nextPage"
          >
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-row>
      </template>
    </v-data-iterator>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default{
  name: 'HomeSimple',
    data: function () {
      return {
        itemsPerPageArray: [4, 8, 12],
        search: '',
        filter: {},
        itHeight:0,
        sortDesc: false,
        page: 1,
        itemsPerPage: 12,
        sortBy: 'facility_display',
        keys: [
          'Client',
          'New',
          'In Progress',
          'Incomplete',
          'QA',
          'Complete',
          'Deficient',
          'Export'
        ],
        rd:{},
        selectedFac:"",
        tabOpts:{},
        codeColumns: []
      }
    },
    watch:{
     
    },
    computed: {
      ...mapGetters(["statuses","proMode"]),
      numberOfPages () {
        return Math.ceil(this.statuses.length / this.itemsPerPage)
      },
      filteredKeys () {
        return this.keys.filter(key => key !== 'Name')
      },
    },
    mounted(){
      this.itHeight = this.$root.vhNum-100;
    },
    methods:{
      openFacility(fac,client,cdis,fdis){
        // console.log ("HOME - SO LONG WE ARE GOING TO: " + fac);
        //this.$store.dispatch("updateFacDocs",{client:client,facility:fac});
        this.$store.dispatch("updateFac",fac);
        this.$store.dispatch("updateClient",client);

        this.$store.dispatch("updateFacClient",{
          facility:fdis,
          client:cdis
        })
        
        this.router('/facility/' + fac);
      },
      nextPage () {
        if (this.page + 1 <= this.numberOfPages) this.page += 1
      },
      formerPage () {
        if (this.page - 1 >= 1) this.page -= 1
      },
      updateItemsPerPage (number) {
        this.itemsPerPage = number
      },
      router(r) {
        this.$router.push({ path: r });
      },
      rowClick(e){
        let selectedFac = e.detail.selectedFac;
        // console.log ("SO LONG WE ARE GOING TO: " + selectedFac);
        this.router('/facility/' + selectedFac);
      }
    }
  };
</script>

<style>
  .tabulator-row .tabulator-cell.tabulator-row-handle .tabulator-row-handle-box .tabulator-row-handle-bar {
    background: white !important;
  }
  .tabulator-edit-select-list .tabulator-edit-select-list-item.active {
    color:limegreen !important;
  }
  .lgBg{
    background:limegreen;
  }
  .liDiFix{
    display: block !important;
  }
</style>


<!--<template v-slot:header>
        <v-toolbar
          :dark="proMode"
          color="blue darken-3"
          class="mb-1"
        >
          <v-text-field
            v-model="search"
            clearable
            flat
            solo-inverted
            hide-details
            prepend-inner-icon="mdi-magnify"
            label="Search"
          ></v-text-field>
          <template v-if="$vuetify.breakpoint.mdAndUp">
            <v-spacer></v-spacer>
            <v-select
              v-model="sortBy"
              flat
              solo-inverted
              hide-details
              :items="keys"
              prepend-inner-icon="mdi-magnify"
              label="Sort by"
            ></v-select>
            <v-spacer></v-spacer>
            <v-btn-toggle
              v-model="sortDesc"
              mandatory
            >
              <v-btn
                large
                depressed
                color="blue"
                :value="false"
              >
                <v-icon>mdi-arrow-up</v-icon>
              </v-btn>
              <v-btn
                large
                depressed
                color="blue"
                :value="true"
              >
                <v-icon>mdi-arrow-down</v-icon>
              </v-btn>
            </v-btn-toggle>
          </template>
        </v-toolbar>
      </template>

      <template v-slot:default="props">
        <v-row>
          <v-col
            v-for="item in props.items"
            :key="item.name"
            cols="12"
            sm="6"
            md="4"
            lg="3"
          >
            <v-card>
              <v-card-title class="subheading font-weight-bold">
                {{ item.name }}
              </v-card-title>

              <v-divider></v-divider>

              <v-list dense>
                <v-list-item
                  v-for="(key, index) in filteredKeys"
                  :key="index"
                >
                  <v-list-item-content :class="{ 'blue--text': sortBy === key }">
                    {{ key }}:
                  </v-list-item-content>
                  <v-list-item-content
                    class="text-center liDiFix"
                    :class="{ 'blue--text': sortBy === key }"
                  >
                    {{ item[key.toLowerCase()] }}
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-col>
        </v-row>
      </template>

      <template v-slot:footer>
        <v-row
          class="mt-2"
          align="center"
          justify="center"
        >
          <span class="grey--text">Items per page</span>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :dark="proMode"
                text
                color="primary"
                class="ml-2"
                v-bind="attrs"
                v-on="on"
              >
                {{ itemsPerPage }}
                <v-icon>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(number, index) in itemsPerPageArray"
                :key="index"
                @click="updateItemsPerPage(number)"
              >
                <v-list-item-title>{{ number }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-spacer></v-spacer>

          <span
            class="mr-4
            grey--text"
          >
            Page {{ page }} of {{ numberOfPages }}
          </span>
          <v-btn
            fab
            :dark="proMode"
            color="blue darken-3"
            class="mr-1"
            @click="formerPage"
          >
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn
            fab
            dark
            color="blue darken-3"
            class="ml-1"
            @click="nextPage"
          >
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-row>
      </template>-->